import { Box, Button } from "@mui/material";

import { ReactComponent as NoResultsSvg } from "assets/images/homepage/sample_analysis.svg";
import ContactCustomerService from "components/auth/ContactCustomerService";
import { HeroText, Para16Text } from "components/shared/Typography";
import UploadTargetsBtn from "components/shared/UploadTargetsBtn";
import useAuth from "hooks/useAuth";

interface EmptyResultsProps {
  hideFooterActions?: boolean;
}

export const EmptyResults: React.FC<EmptyResultsProps> = ({
  hideFooterActions = false,
}) => {
  const { isLoggedIn } = useAuth();

  return (
    <Box
      id="catalog-empty-results"
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={{ xs: "16px", sm: "24px" }}
      paddingBottom={3}
    >
      <NoResultsSvg width={80} height={80} />
      <HeroText component="h2">We didn't find any exact match.</HeroText>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="24px"
      >
        <Para16Text component="p" align="center">
          Check the spelling or use a more general term.
        </Para16Text>
        <ContactCustomerService
          textProps={{
            variant: "body1",
            className: undefined,
          }}
          linkProps={{ color: "secondary" }}
        />
      </Box>
      {isLoggedIn && !hideFooterActions && (
        <Box display="flex" gap="16px" justifyContent="center">
          <UploadTargetsBtn />
          <Button href="/catalog" variant="outlined" color="primary">
            Browse catalog
          </Button>
        </Box>
      )}
    </Box>
  );
};
